export const COLUMN_IDS = {
    CHANNEL_NAME: 'channelName',
    TRACK_NAME: 'trackName',
    PROGRAM_AND_SERIES: 'programAndSeries',
    SURVEY_TYPE: 'surveyType',
    USE_CODE: 'useCode',
    DETECTIONS: 'detections',
    GAP: 'gap',
    PERFORMANCES: 'performances',
    ESTIMATED_LOSS: 'estimatedLoss',
};

export const defaultColumnWidth = 200;
export const tableHeight = 510;
export const tableWidth = 900;
export const rowHeight = 50;
export const subRowHeight = 50;
export const headerHeight = 40;
export const subHeaderHeight = 15;
export const footerHeight = 50;
export const caretIconWidth = 10;

export const columnWidths = {
    [COLUMN_IDS.CHANNEL_NAME]: 80,
    [COLUMN_IDS.TRACK_NAME]: 190,
    [COLUMN_IDS.PROGRAM_AND_SERIES]: 130,
    [COLUMN_IDS.SURVEY_TYPE]: 100,
    [COLUMN_IDS.USE_CODE]: 100,
    [COLUMN_IDS.DETECTIONS]: 65,
    [COLUMN_IDS.GAP]: 50,
    [COLUMN_IDS.PERFORMANCES]: 60,
    [COLUMN_IDS.ESTIMATED_LOSS]: 140,
};

// This adds extra padding between the CHANNEL_NAME cell and the next cell over
export const channelNamePadding = 40;

// The CHANNEL_NAME cell is only rendered for channel row groups, whereas the cells for TRACK_NAME,
// PROGRAM_AND_SERIES, SURVEY_TYPE and USE_CODE are only rendered for sub-rows. This means we can
// use the extra width from these columns to increase the width of the CHANNEL_NAME cell as well
// as the CHANNEL_NAME footer.
export const EXTRA_CELL_WIDTH = {
    [COLUMN_IDS.CHANNEL_NAME]:
        columnWidths[COLUMN_IDS.TRACK_NAME] +
        columnWidths[COLUMN_IDS.PROGRAM_AND_SERIES] +
        columnWidths[COLUMN_IDS.SURVEY_TYPE] +
        columnWidths[COLUMN_IDS.USE_CODE] -
        channelNamePadding,
};

export const modalWidth = 1000;
export const modalHeight = 710;

export const summarizeRowsAbove = 1;
